import { render, staticRenderFns } from "./ViewReclamationInvoiceGross.vue?vue&type=template&id=1bfe3ba4&"
import script from "./ViewReclamationInvoiceGross.vue?vue&type=script&lang=js&"
export * from "./ViewReclamationInvoiceGross.vue?vue&type=script&lang=js&"
import style0 from "./ViewReclamationInvoiceGross.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports